import * as React from 'react';
import { EditButton, Identifier, Labeled, NumberField, Record, RecordMap, TextField } from 'react-admin';
import { Card, CardContent, CardHeader } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TranslateField } from "../components/TranslateField";

const useListStyles = makeStyles(theme => ({
	card: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		margin: '1.5rem 0',
		boxShadow: '0px 15px 20px #27313f0c !important',
		backgroundColor: 'white'
	},
	cardTitleContent: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	cardContent: theme.typography.body1,
	cardContentRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		margin: '0.5rem 0',
		fontWeight: 'bold'
	}
}));

interface OrganizationCoachNotificationListProps {
	ids?: Identifier[];
	data?: RecordMap<Record>;
	basePath?: string;
}

export const OrganizationCoachNotificationList = (props: OrganizationCoachNotificationListProps) => {
	const { ids, data, basePath } = props;
	const classes = useListStyles();

	if (!ids || !data || !basePath) {
		return null;
	}

	return (
		<div style={{ margin: '1em', backgroundColor: '#F8F9FC' }} className="list-container">
			{ids.map(id => (
				<Card key={id} className={classes.card}>
					<CardHeader
						title={
							<div className={classes.cardTitleContent}>
                                <span>
                                    {data[id].name}
                                </span>
								<EditButton
									resource="organization-coach-notifications"
									basePath={basePath}
									record={data[id]}
								/>
							</div>
						}
					/>
					<CardContent className={classes.cardContent}>
						<Labeled label="NUMBER_OF_DAYS_SINCE_CLIENT_START" className={classes.cardContentRow}>
							<NumberField record={data[id]} source="numberOfDaysSinceClientStart"
							             label="NUMBER_OF_DAYS_SINCE_CLIENT_START"/>
						</Labeled>
						<Labeled label="TITLE" className={classes.cardContentRow}>
							<TextField record={data[id]} source="title" label="TITLE"/>
						</Labeled>
						<Labeled label="BODY" className={classes.cardContentRow}>
							<TextField record={data[id]} source="body" label="BODY"/>
						</Labeled>
						<Labeled label="LANGUAGE" className={classes.cardContentRow}>
							<TranslateField record={data[id]} source="language" label="LANGUAGE"/>
						</Labeled>
					</CardContent>
				</Card>
			))}
		</div>
	);
};
